import React from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { ResponsivePie } from '@nivo/pie';

import { CustomContainer } from '../common';
import { getNivoTheme, CHART_HEIGHT, CHART_HEIGHT_MOBILE } from './utils';

export default ({
  colors,
  data,
  isFetching,
  isMobile,
  title,
}) => (
  <CustomContainer>
    <Header as={isMobile ? 'h3' : 'h2'} attached="top">
      {title}
    </Header>
    <Segment
      attached
      loading={isFetching}
      style={{ height: isMobile ? CHART_HEIGHT_MOBILE : CHART_HEIGHT }}
    >
      <ResponsivePie
        theme={getNivoTheme(isMobile)}
        data={data}
        margin={{ top: 40, right: 80, bottom: 40, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        colors={colors || { scheme: 'nivo' }}
        borderWidth={1}
        borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
        radialLabelsSkipAngle={10}
        radialLabelsTextColor="#333333"
        radialLabelsLinkColor={{ from: 'color' }}
        sliceLabelsSkipAngle={10}
        sliceLabelsTextColor="#333333"
      />
    </Segment>
  </CustomContainer>
);
